(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cookie-banner"] && !Shopify.designMode) return;
  try {
    (() => {
    const banner = document.querySelector('[data-cookie-banner]')
    const backdrop = document.querySelector('[data-cookie-backdrop]')
    const policyModal = document.querySelector('[data-cookie-policy-modal]')
    const policyPanel = policyModal?.querySelector('.cookie-policy-modal__panel')
    if (!banner || !backdrop || banner.dataset.init) return
    banner.dataset.init = 'true'

    const KEY = 'theme-cookie-consent'

    const policyOpenBtn = banner.querySelector('[data-cookie-policy-open]')
    const prefsPanel = banner.querySelector('[data-cookie-prefs]')
    const manageBtn = banner.querySelector('[data-cookie-manage]')
    const acceptBtn = banner.querySelector('[data-cookie-accept]')
    const analyticsInput = banner.querySelector('[data-cookie-pref="analytics"]')
    const marketingInput = banner.querySelector('[data-cookie-pref="marketing"]')

    const readStored = () => {
      try {
        const raw = localStorage.getItem(KEY)
        if (!raw) return null
        if (raw === 'accepted') return { analytics: true, marketing: true }
        if (raw === 'essential') return { analytics: false, marketing: false }
        if (raw === 'managed') return { analytics: false, marketing: false }
        if (raw.startsWith('managed:')) {
          const parts = raw.split(':')
          return {
            analytics: parts[1] === '1',
            marketing: parts[2] === '1',
          }
        }
      } catch (e) {}
      return null
    }

    const writeStored = (analytics, marketing) => {
      let value = 'essential'
      if (analytics && marketing) value = 'accepted'
      else if (!analytics && !marketing) value = 'essential'
      else value = `managed:${analytics ? '1' : '0'}:${marketing ? '1' : '0'}`
      try {
        localStorage.setItem(KEY, value)
      } catch (e) {}
    }

    const applyPrefsToInputs = (stored) => {
      if (!stored || !analyticsInput || !marketingInput) return
      analyticsInput.checked = stored.analytics
      marketingInput.checked = stored.marketing
    }

    manageBtn?.addEventListener('click', () => {
      const open = manageBtn.getAttribute('aria-expanded') === 'true'
      manageBtn.setAttribute('aria-expanded', String(!open))
      prefsPanel.hidden = open
    })

    let cookieTrap = null
    let policyTrap = null

    const closePolicyModal = () => {
      if (!policyModal) return
      policyTrap?.deactivate()
      policyTrap = null
      policyModal.classList.remove('is-visible')
      setTimeout(() => {
        policyModal.hidden = true
      }, 300)
      if (banner.classList.contains('is-visible')) {
        cookieTrap = window.FroartFocusTrap?.activate(banner)
        policyOpenBtn?.focus()
      }
    }

    const openPolicyModal = () => {
      if (!policyModal || !policyPanel) return
      policyModal.hidden = false
      requestAnimationFrame(() => {
        policyModal.classList.add('is-visible')
        cookieTrap?.deactivate()
        cookieTrap = null
        policyTrap = window.FroartFocusTrap?.activate(policyPanel)
      })
    }

    policyOpenBtn?.addEventListener('click', (event) => {
      event.preventDefault()
      openPolicyModal()
    })

    policyModal?.addEventListener('click', (event) => {
      if (event.target.closest('[data-cookie-policy-close]')) {
        event.preventDefault()
        closePolicyModal()
      }
    })

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !policyModal || policyModal.hidden) return
      event.preventDefault()
      closePolicyModal()
    })

    const show = (focusManage = false) => {
      const stored = readStored()
      applyPrefsToInputs(stored)
      banner.hidden = false
      backdrop.hidden = false
      requestAnimationFrame(() => {
        backdrop.classList.add('is-visible')
        banner.classList.add('is-visible')
        cookieTrap = window.FroartFocusTrap?.activate(banner)
        if (focusManage) manageBtn?.focus()
        else acceptBtn?.focus()
      })
    }

    const resolve = () => {
      cookieTrap?.deactivate()
      cookieTrap = null
      backdrop.classList.remove('is-visible')
      banner.classList.remove('is-visible')
      setTimeout(() => {
        backdrop.hidden = true
        banner.hidden = true
        document.dispatchEvent(new CustomEvent('theme:cookie-resolved'))
      }, 300)
    }

    const syncConsent = (analytics, marketing) => {
      window.Shopify?.customerPrivacy?.setTrackingConsent?.(
        { analytics, marketing, preferences: false, sale_of_data: false },
        () => {}
      )
    }

    const save = (analytics, marketing) => {
      writeStored(analytics, marketing)
      syncConsent(analytics, marketing)
      resolve()
    }

    acceptBtn?.addEventListener('click', () => {
      save(true, true)
    })

    banner.querySelector('[data-cookie-essential]')?.addEventListener('click', () => {
      save(false, false)
    })

    banner.querySelector('[data-cookie-save]')?.addEventListener('click', () => {
      save(analyticsInput?.checked ?? false, marketingInput?.checked ?? false)
    })

    const openPreferences = () => {
      manageBtn?.setAttribute('aria-expanded', 'true')
      if (prefsPanel) prefsPanel.hidden = false
      show(true)
    }

    window.FroartCookieBanner = { open: openPreferences }

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest?.('[data-cookie-settings-open]')
      if (!trigger) return
      event.preventDefault()
      openPreferences()
    })

    const suppressAutoshow = banner.dataset.cookieSuppressAutoshow === 'true'

    const init = () => {
      const stored = readStored()
      if (stored) syncConsent(stored.analytics, stored.marketing)

      const shouldShow = window.Shopify?.customerPrivacy?.shouldShowBanner?.() ?? true
      if (shouldShow && !stored && !suppressAutoshow) setTimeout(() => show(false), 1200)
      else document.dispatchEvent(new CustomEvent('theme:cookie-resolved'))
    }

    if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], init)
    } else {
      init()
    }
  })()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["deferred-chrome"] && !Shopify.designMode) return;
  try {
    (() => {
    const configEl = document.getElementById('froart-deferred-assets')
    if (!configEl) return

    const config = JSON.parse(configEl.textContent)
    const pending = new Map()
    const latePending = new Map()
    let cartBroken = false
    let headerBroken = false

    const lateNodes = (kind) => {
      const selector = kind === 'all' ? '[data-froart-late]' : `[data-froart-late="${kind}"]`
      return [...document.querySelectorAll(`script${selector}, link${selector}`)]
    }

    const copyNonce = (from, to) => {
      const nonce = from.getAttribute('nonce') || from.nonce
      if (nonce) to.setAttribute('nonce', nonce)
    }

    const activateLateNode = (node) => {
      if (node.dataset.froartLateLoaded === 'true') return Promise.resolve()
      node.dataset.froartLateLoaded = 'true'

      if (node.dataset.froartLateInline === 'true') {
        const inline = document.createElement('script')
        copyNonce(node, inline)
        if (node.dataset.froartLateModule === 'true') inline.type = 'module'
        inline.text = node.textContent
        document.head.appendChild(inline)
        return Promise.resolve()
      }

      if (node.localName === 'link') {
        const href = node.getAttribute('data-froart-late-href') || node.getAttribute('href')
        if (!href) return Promise.resolve()
        node.href = href
        node.rel = 'stylesheet'
        return Promise.resolve()
      }

      const src = node.getAttribute('data-froart-late-src') || node.getAttribute('src')
      if (!src) return Promise.resolve()
      return new Promise((resolve) => {
        const script = document.createElement('script')
        copyNonce(node, script)
        script.src = src
        if (node.dataset.froartLateModule === 'true') script.type = 'module'
        else script.async = true
        const integrity = node.getAttribute('integrity')
        if (integrity) script.integrity = integrity
        if (node.hasAttribute('crossorigin')) script.crossOrigin = node.getAttribute('crossorigin') || 'anonymous'
        script.onload = () => resolve()
        script.onerror = () => resolve()
        document.head.appendChild(script)
      })
    }

    const activateLate = (kind) => {
      const key = kind || 'all'
      if (!latePending.has(key)) {
        latePending.set(key, Promise.all(lateNodes(key).map(activateLateNode)))
      }
      return latePending.get(key)
    }

    window.FroartLateAssets = { activate: activateLate }

    const loadCss = (href, key) => {
      const existing = document.querySelector(`link[data-froart="${key}"]`)
      if (existing) {
        if (existing.dataset.froartState === 'eager' || existing.dataset.loaded === 'true') {
          return Promise.resolve()
        }
        return new Promise((resolve, reject) => {
          existing.addEventListener('load', () => resolve(), { once: true })
          existing.addEventListener('error', () => reject(new Error(key)), { once: true })
        })
      }

      return new Promise((resolve, reject) => {
        const link = document.createElement('link')
        link.rel = 'stylesheet'
        link.href = href
        link.dataset.froart = key
        link.onload = () => {
          link.dataset.loaded = 'true'
          resolve()
        }
        link.onerror = () => reject(new Error(key))
        document.head.appendChild(link)
      })
    }

    const loadScript = (src, key) => {
      if (key === 'cart-engine' && window.FroartCart) return Promise.resolve()
      if (key === 'header-behavior' && window.__froartHeaderReady) return Promise.resolve()

      const existing = document.querySelector(`script[data-froart="${key}"]`)
      if (existing) {
        if (existing.dataset.loaded === 'true' || (key === 'cart-engine' && window.FroartCart)) {
          return Promise.resolve()
        }
        return new Promise((resolve, reject) => {
          existing.addEventListener('load', () => resolve(), { once: true })
          existing.addEventListener('error', () => reject(new Error(key)), { once: true })
        })
      }

      return new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = src
        script.async = false
        script.dataset.froart = key
        script.onload = () => {
          script.dataset.loaded = 'true'
          resolve()
        }
        script.onerror = () => reject(new Error(key))
        document.head.appendChild(script)
      })
    }

    const loadSet = (name, jobs) => {
      if (!pending.has(name)) {
        pending.set(name, Promise.all(jobs).then(() => {
          if (name === 'header') window.__froartHeaderReady = true
        }))
      }
      return pending.get(name)
    }

    const loadCart = () => {
      activateLate('cart')
      return loadSet('cart', [
        loadCss(config.cartDrawerCss, 'cart-drawer'),
        loadScript(config.cartEngine, 'cart-engine')
      ])
    }

    const loadHeader = () => loadSet('header', [
      loadCss(config.headerDeferredCss, 'header-deferred'),
      loadScript(config.headerBehavior, 'header-behavior')
    ]).then(() => {
      document.querySelectorAll('.header__mega-item:hover').forEach((mega) => {
        mega.dispatchEvent(new MouseEvent('mouseenter', { bubbles: false }))
      })
    })

    const cartIntent = (node) => node?.closest?.('[data-open-cart], form[action*="/cart/add"]')

    document.addEventListener('pointerover', (event) => {
      if (cartBroken || window.FroartCart) return
      if (!cartIntent(event.target)) return
      loadCart().catch(() => { cartBroken = true })
    }, true)

    document.addEventListener('click', (event) => {
      if (cartBroken || window.FroartCart) return
      const link = event.target?.closest?.('[data-open-cart]')
      if (!link) return
      event.preventDefault()
      event.stopPropagation()
      loadCart().then(() => link.click()).catch(() => {
        cartBroken = true
        window.location.href = link.href
      })
    }, true)

    document.addEventListener('submit', (event) => {
      if (cartBroken || window.FroartCart) return
      const form = event.target?.closest?.('form[action*="/cart/add"]')
      if (!form) return
      event.preventDefault()
      event.stopPropagation()
      const submitter = event.submitter
      loadCart().then(() => {
        if (typeof form.requestSubmit === 'function') form.requestSubmit(submitter || undefined)
        else form.submit()
      }).catch(() => {
        cartBroken = true
        form.submit()
      })
    }, true)

    document.addEventListener('click', (event) => {
      if (headerBroken || window.__froartHeaderReady) return
      const trigger = event.target?.closest?.('.header__mobile-toggle, .header__search-toggle')
      if (!trigger) return
      event.preventDefault()
      event.stopPropagation()
      loadHeader().then(() => trigger.click()).catch(() => { headerBroken = true })
    }, true)

    document.addEventListener('pointerover', (event) => {
      if (headerBroken || window.__froartHeaderReady) return
      if (!event.target?.closest?.('.header__menu, .header__mobile-toggle, .header__search-toggle, #header-drawer')) return
      loadHeader().catch(() => { headerBroken = true })
    }, true)

    document.addEventListener('focusin', (event) => {
      if (headerBroken || window.__froartHeaderReady) return
      if (!event.target?.closest?.('.header__mobile-toggle, .header__search-toggle, .header__menu')) return
      loadHeader().catch(() => { headerBroken = true })
    }, true)

    if (config.designMode) {
      loadHeader().catch(() => { headerBroken = true })
      loadCart().catch(() => { cartBroken = true })
    }
  })()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["focus-trap"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.FroartFocusTrap) return

    window.FroartFocusTrap = {
      activate(container, options = {}) {
        const main = document.querySelector('.theme-main')
        const header = document.querySelector('.site-header')
        const footer = document.querySelector('.site-footer')
        const previouslyFocused = document.activeElement
        const containerInHeader = Boolean(header && header.contains(container))

        if (main) main.inert = true
        if (header && !containerInHeader) header.inert = true
        if (footer) footer.inert = true

        const getFocusables = () => Array.from(
          container.querySelectorAll(
            'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
          )
        ).filter((el) => !el.hidden && el.getAttribute('aria-hidden') !== 'true')

        const onKeyDown = (event) => {
          if (event.key !== 'Tab') return
          const focusables = getFocusables()
          if (!focusables.length) return
          const first = focusables[0]
          const last = focusables[focusables.length - 1]
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault()
            last.focus()
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault()
            first.focus()
          }
        }

        document.addEventListener('keydown', onKeyDown)

        return {
          deactivate() {
            document.removeEventListener('keydown', onKeyDown)
            if (main) main.inert = false
            if (header) header.inert = false
            if (footer) footer.inert = false
            const target = options.restoreFocus || previouslyFocused
            if (target && typeof target.focus === 'function') target.focus()
          },
        }
      },
    }
  })()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["froart-carousel-assets"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.FroartCarousel) return

    const shouldWarmCarouselImages = () => {
      const conn = navigator.connection
      if (!conn) return true
      if (conn.saveData) return false
      if (conn.effectiveType === 'slow-2g' || conn.effectiveType === '2g') return false
      return true
    }

    const runWhenIdle = (callback, timeout) => {
      if (typeof requestIdleCallback === 'function') {
        requestIdleCallback(callback, { timeout: timeout || 4000 })
        return
      }
      setTimeout(callback, 50)
    }

    const runAfterLoad = (callback, delay) => {
      let scheduled = false
      const schedule = () => {
        if (scheduled) return
        scheduled = true
        setTimeout(() => runWhenIdle(callback, 1000), Math.max(0, delay || 0))
      }

      if (document.readyState === 'complete') schedule()
      else window.addEventListener('load', schedule, { once: true })
    }

    const warmCarouselImage = (img) => {
      if (!img || img.dataset.carouselWarmed === 'true') return
      img.dataset.carouselWarmed = 'true'

      const src = img.getAttribute('src')
      const srcset = img.getAttribute('srcset')
      if (!src && !srcset) return

      const loader = new Image()
      loader.decoding = 'async'
      if ('fetchPriority' in loader) loader.fetchPriority = 'low'
      if (srcset) loader.srcset = srcset
      const sizes = img.getAttribute('sizes')
      if (sizes) loader.sizes = sizes
      if (src) loader.src = src
    }

    const warmSlideImages = (slide) => {
      if (!slide) return
      const targets = slide.querySelectorAll(
        '.product-card__image--primary img, .brand-pillars__card-img'
      )
      if (targets.length) {
        targets.forEach(warmCarouselImage)
        return
      }
      slide.querySelectorAll('img').forEach((img) => {
        if (img.closest('button, .product-card__wishlist')) return
        warmCarouselImage(img)
      })
    }

    const scheduleCarouselImageWarm = (carousel, slides, getActiveIndex) => {
      if (!shouldWarmCarouselImages() || slides.length < 2) return
      // Pillars are a grid on desktop — the visible cards lazy-load themselves.
      if (
        carousel.classList.contains('froart-carousel--pillars') &&
        window.matchMedia('(min-width: 768px)').matches
      ) return

      let queueIndex = 0
      let started = false
      let queue = []
      let proximityObserver

      const isVisible = () => {
        const style = window.getComputedStyle(carousel)
        return style.display !== 'none' && style.visibility !== 'hidden'
      }

      const isMobile = () => window.matchMedia('(max-width: 767px)').matches

      const rebuildQueue = () => {
        const activeIndex = getActiveIndex()
        queue = [...slides]
          .map((slide, i) => ({
            slide,
            priority: Math.abs(i - activeIndex),
          }))
          .filter((item) => item.priority > 0)
          .sort((a, b) => a.priority - b.priority)

        // Mobile: only the next slide — keep Lighthouse / main thread light.
        if (isMobile()) {
          queue = queue.filter((item) => item.priority === 1).slice(0, 1)
        }
        queueIndex = 0
      }

      const preloadNext = () => {
        if (queueIndex >= queue.length) return
        warmSlideImages(queue[queueIndex].slide)
        queueIndex += 1
        if (queueIndex < queue.length) {
          setTimeout(() => runWhenIdle(preloadNext, 1000), 1800)
        }
      }

      const startWarm = () => {
        if (started || !shouldWarmCarouselImages() || !isVisible()) return
        started = true
        proximityObserver?.disconnect()
        rebuildQueue()
        preloadNext()
      }

      const startWhenNear = () => {
        if (started || !isVisible()) return

        if (typeof IntersectionObserver === 'undefined') {
          runAfterLoad(startWarm, 4000)
          return
        }

        proximityObserver = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return
            startWarm()
          },
          { rootMargin: isMobile() ? '120px 0px' : '400px 0px' }
        )
        proximityObserver.observe(carousel)
      }

      // After load only — never warm from initial layout proximity (hurts mobile TBT).
      runAfterLoad(startWhenNear, 2500)

      // Product rails: first card is eager in Liquid; warm the next primary right after load.
      if (
        carousel.classList.contains('froart-carousel--products') &&
        slides.length > 1
      ) {
        runAfterLoad(() => {
          if (!shouldWarmCarouselImages()) return
          warmSlideImages(slides[1])
        }, 600)
      }

      const warmLikelyNext = () => {
        if (!shouldWarmCarouselImages()) return
        const activeIndex = getActiveIndex()
        warmSlideImages(slides[Math.min(slides.length - 1, activeIndex + 1)])
        if (!isMobile()) {
          warmSlideImages(slides[Math.min(slides.length - 1, activeIndex + 2)])
        }
      }

      carousel.addEventListener('pointerdown', warmLikelyNext, { passive: true })
      window.addEventListener('resize', () => {
        if (!started && document.readyState === 'complete') startWhenNear()
      })
    }

    const initOne = (carousel) => {
      if (!carousel || carousel.dataset.carouselInit === 'true') return
      carousel.dataset.carouselInit = 'true'

      const track = carousel.querySelector('[data-carousel-track]')
      const prevButton = carousel.querySelector('[data-carousel-prev]')
      const nextButton = carousel.querySelector('[data-carousel-next]')
      const slides = carousel.querySelectorAll('[data-carousel-slide]')
      const currentEl = carousel.querySelector('[data-carousel-current]')
      const mode = carousel.dataset.carouselMode || 'step'
      const total = slides.length

      if (!track || !prevButton || !nextButton || total < 1) return

      if (total < 2) {
        prevButton.hidden = true
        nextButton.hidden = true
        return
      }

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
      const scrollBehavior = reduceMotion ? 'auto' : 'smooth'

      const getVisibleSlides = () => {
        if (mode === 'paged') return 1
        if (carousel.classList.contains('froart-carousel--instagram')) {
          if (window.matchMedia('(min-width: 1400px)').matches) return 6
          if (window.matchMedia('(min-width: 768px)').matches) return 4
          return 2
        }
        if (window.matchMedia('(min-width: 1400px)').matches) return 4
        if (window.matchMedia('(min-width: 768px)').matches) return 3
        return 1
      }

      const getSlideStep = () => {
        const firstSlide = slides[0]
        const secondSlide = slides[1]
        if (secondSlide) {
          const step = secondSlide.offsetLeft - firstSlide.offsetLeft
          if (step > 0) return step
        }
        return firstSlide.offsetWidth || track.clientWidth
      }

      const getActiveIndex = () => {
        const step = getSlideStep()
        if (step <= 0) return 0
        return Math.min(total - 1, Math.max(0, Math.round(track.scrollLeft / step)))
      }

      const updateButtons = () => {
        if (mode === 'paged' || currentEl) {
          const index = getActiveIndex()
          if (currentEl) currentEl.textContent = String(index + 1)
          prevButton.disabled = index <= 0
          nextButton.disabled = index >= total - 1
          return
        }

        const maxScrollLeft = track.scrollWidth - track.clientWidth
        prevButton.disabled = track.scrollLeft <= 4
        nextButton.disabled = track.scrollLeft >= maxScrollLeft - 4
      }

      const scrollBySlide = (direction) => {
        const step = getSlideStep()
        const pages = mode === 'paged' ? 1 : getVisibleSlides()
        const nextIndex = Math.min(
          total - 1,
          Math.max(0, getActiveIndex() + pages * direction)
        )
        warmSlideImages(slides[nextIndex])

        track.scrollBy({
          left: step * pages * direction,
          behavior: scrollBehavior,
        })
      }

      prevButton.addEventListener('click', () => scrollBySlide(-1))
      nextButton.addEventListener('click', () => scrollBySlide(1))
      track.addEventListener('scroll', updateButtons, { passive: true })
      window.addEventListener('resize', updateButtons)
      updateButtons()
      scheduleCarouselImageWarm(carousel, slides, getActiveIndex)
    }

    const init = (root = document) => {
      const scope = root && root.querySelectorAll ? root : document
      const carousels =
        scope.matches && scope.matches('[data-carousel]')
          ? [scope]
          : scope.querySelectorAll('[data-carousel]')

      carousels.forEach(initOne)
    }

    window.FroartCarousel = { init, initOne }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init())
    } else {
      init()
    }
  })()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-layout"] && !Shopify.designMode) return;
  try {
    (() => {
    const isTabletUp = window.matchMedia('(min-width: 768px)')

    const normalizePath = (path) => {
      if (!path) return ''
      const cleanPath = path.replace(/\/+$/, '')
      return cleanPath === '' ? '/' : cleanPath
    }

    const normalizeHandle = (value) => (value || '').trim().toLowerCase()
      .replace(/['"]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')

    document.querySelectorAll('.site-header').forEach((header) => {
      const menu = header.querySelector('.header__menu')
      const icons = header.querySelector('.header__icons')

      const syncActiveCategoryFromUrl = () => {
        const currentUrl = new URL(window.location.href)
        const collectionType = currentUrl.searchParams.get('filter.p.m.custom.collection_type')
        const isAllCollections = currentUrl.pathname.includes('/collections/all')

        const menuLinks = Array.from(header.querySelectorAll('.header__menu-link'))
        menuLinks.forEach((linkEl) => {
          linkEl.classList.remove('is-active')
          linkEl.removeAttribute('aria-current')
        })

        header.querySelectorAll('.header__mega-link').forEach((linkEl) => {
          linkEl.classList.remove('is-current', 'is-active')
          linkEl.removeAttribute('aria-current')
        })

        const currentPath = normalizePath(currentUrl.pathname)

        if (isAllCollections && collectionType) {
          const selectedHandle = normalizeHandle(collectionType)
          const matchingLink = menuLinks.find((linkEl) => {
            const filterValue = linkEl.dataset.filterValue || ''
            const canonicalType = linkEl.dataset.collectionType || ''
            if (filterValue && normalizeHandle(filterValue) === selectedHandle) return true
            if (canonicalType && normalizeHandle(canonicalType) === selectedHandle) return true
            const labelHandle = normalizeHandle(linkEl.textContent || '')
            return labelHandle === selectedHandle
          })

          if (matchingLink) {
            matchingLink.classList.add('is-active')
            matchingLink.setAttribute('aria-current', 'page')
          }

          return
        }

        if (currentPath.includes('/collections/')) {
          const megaItems = Array.from(header.querySelectorAll('.header__mega'))
          for (const mega of megaItems) {
            const trigger = mega.querySelector('.header__mega-trigger')
            const childLinks = Array.from(mega.querySelectorAll('.header__mega-link'))
            const childMatch = childLinks.some((childLink) => {
              const childUrl = new URL(childLink.href, window.location.origin)
              return normalizePath(childUrl.pathname) === currentPath
            })

            if (childMatch && trigger) {
              trigger.classList.add('is-active')
              trigger.setAttribute('aria-current', 'page')
              childLinks.forEach((childLink) => {
                const childUrl = new URL(childLink.href, window.location.origin)
                const isMatch = normalizePath(childUrl.pathname) === currentPath
                childLink.classList.toggle('is-current', isMatch)
                childLink.classList.toggle('is-active', isMatch)
                if (isMatch) childLink.setAttribute('aria-current', 'page')
              })
              return
            }
          }
        }

        const directMatch = menuLinks.find((linkEl) => {
          const linkUrl = new URL(linkEl.href, window.location.origin)
          return normalizePath(linkUrl.pathname) === currentPath
        })

        if (directMatch) {
          directMatch.classList.add('is-active')
          directMatch.setAttribute('aria-current', 'page')
        }

        if (menu) {
          menu.classList.add('is-nav-synced')
        }
      }

      const syncHeaderOffset = () => {
        if (header.classList.contains('site-header--static')) {
          document.documentElement.style.removeProperty('--site-header-offset')
          return
        }

        const height = Math.ceil(header.getBoundingClientRect().height)
        if (height > 0) {
          document.documentElement.style.setProperty('--site-header-offset', `${height}px`)
        }
      }

      const syncMenuLayout = () => {
        if (!menu || !icons) {
          syncHeaderOffset()
          return
        }

        if (!isTabletUp.matches) {
          header.classList.remove('site-header--menu-below')
          syncHeaderOffset()
          return
        }

        header.classList.remove('site-header--menu-below')

        const menuList = menu.querySelector('.header__menu-list') || menu
        const overlapTolerancePx = 0.5
        const separatorClearancePx = 8
        const menuContainerRect = menu.getBoundingClientRect()
        const menuRect = menuList.getBoundingClientRect()
        const iconsRect = icons.getBoundingClientRect()
        const separatorEdge = menuContainerRect.left + separatorClearancePx
        const overflowsLeft = menuRect.left < separatorEdge - overlapTolerancePx
        const overflowsRight = menuRect.right > iconsRect.left + overlapTolerancePx

        if (overflowsLeft || overflowsRight) {
          header.classList.add('site-header--menu-below')
        }

        syncHeaderOffset()
      }

      syncActiveCategoryFromUrl()
      syncHeaderOffset()

      const currentPath = normalizePath(window.location.pathname)
      const rootPath = normalizePath(header.dataset.rootPath || '/')
      const isHomepage = currentPath === rootPath
      const hero = document.querySelector('.hero')
      if (isHomepage && hero) {
        let isUpdatingHeroMix = false
        const startMixPercent = 60
        const endMixPercent = 100

        const updateHeroHeaderMix = () => {
          isUpdatingHeroMix = false

          const heroRect = hero.getBoundingClientRect()
          const heroHeight = heroRect.height
          if (heroHeight <= 0) {
            header.style.removeProperty('--header-scroll-mix-percent')
            return
          }

          const heroTop = window.scrollY + heroRect.top
          const start = heroTop
          const end = heroTop + heroHeight
          const marker = window.scrollY + header.getBoundingClientRect().height

          if (marker <= start) {
            header.style.setProperty('--header-scroll-mix-percent', `${startMixPercent}%`)
            return
          }

          if (marker >= end) {
            header.style.setProperty('--header-scroll-mix-percent', `${endMixPercent}%`)
            return
          }

          const progress = (marker - start) / (end - start)
          const mix = startMixPercent + (endMixPercent - startMixPercent) * progress
          header.style.setProperty('--header-scroll-mix-percent', `${mix.toFixed(2)}%`)
        }

        const requestHeroHeaderMixUpdate = () => {
          if (isUpdatingHeroMix) return
          isUpdatingHeroMix = true
          requestAnimationFrame(updateHeroHeaderMix)
        }

        const armHeroMix = () => {
          requestHeroHeaderMixUpdate()
          window.addEventListener('scroll', requestHeroHeaderMixUpdate, { passive: true })
          window.addEventListener('resize', requestHeroHeaderMixUpdate)
        }

        if (document.readyState === 'complete') {
          requestAnimationFrame(armHeroMix)
        } else {
          window.addEventListener('load', () => requestAnimationFrame(armHeroMix), { once: true })
        }
      } else {
        header.style.setProperty('--header-scroll-mix-percent', '100%')
      }

      const scheduleMenuLayout = () => {
        if (!isTabletUp.matches) {
          syncHeaderOffset()
          return
        }
        requestAnimationFrame(syncMenuLayout)
      }

      const armLayout = () => {
        scheduleMenuLayout()
        window.addEventListener('resize', scheduleMenuLayout)
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(scheduleMenuLayout)
        }
        if (typeof ResizeObserver !== 'undefined') {
          const layoutObserver = new ResizeObserver(scheduleMenuLayout)
          layoutObserver.observe(header)
          if (menu) layoutObserver.observe(menu)
          if (icons) layoutObserver.observe(icons)
        }
      }

      if (document.readyState === 'complete') {
        setTimeout(armLayout, 150)
      } else {
        window.addEventListener('load', () => setTimeout(armLayout, 150), { once: true })
      }
      window.addEventListener('pageshow', syncActiveCategoryFromUrl)
    })
  })()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["image-warm"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.FroartImageWarm) return

    const warmedKeys = new Set()

    const shouldWarm = () => {
      const conn = navigator.connection
      if (!conn) return true
      if (conn.saveData) return false
      if (conn.effectiveType === 'slow-2g' || conn.effectiveType === '2g') return false
      return true
    }

    const runWhenIdle = (callback, timeout) => {
      if (typeof requestIdleCallback === 'function') {
        requestIdleCallback(callback, { timeout: timeout || 3000 })
        return
      }
      setTimeout(callback, 50)
    }

    const runAfterLoad = (callback, delay) => {
      let scheduled = false
      const schedule = () => {
        if (scheduled) return
        scheduled = true
        setTimeout(() => runWhenIdle(callback, 1000), Math.max(0, delay || 0))
      }

      if (document.readyState === 'complete') schedule()
      else window.addEventListener('load', schedule, { once: true })
    }

    const resolveCandidate = (img) => {
      const picture = img.closest('picture')
      if (picture) {
        const sources = [...picture.querySelectorAll('source')]
        for (const source of sources) {
          const media = source.getAttribute('media')
          if (!media || window.matchMedia(media).matches) {
            return {
              srcset: source.getAttribute('srcset'),
              sizes: source.getAttribute('sizes') || img.getAttribute('sizes'),
              src: img.getAttribute('src'),
            }
          }
        }
      }

      return {
        srcset: img.getAttribute('srcset'),
        sizes: img.getAttribute('sizes'),
        src: img.getAttribute('src') || img.currentSrc || '',
      }
    }

    const warmImg = (img) => {
      if (!img || img.dataset.imageWarmed === 'true') return false
      img.dataset.imageWarmed = 'true'

      const candidate = resolveCandidate(img)
      if (!candidate.src && !candidate.srcset) return false

      const cacheKey = `${candidate.src || ''}|${candidate.srcset || ''}|${candidate.sizes || ''}`
      if (warmedKeys.has(cacheKey)) return false
      warmedKeys.add(cacheKey)

      const loader = new Image()
      loader.decoding = 'async'
      if ('fetchPriority' in loader) loader.fetchPriority = 'low'
      if (candidate.srcset) loader.srcset = candidate.srcset
      if (candidate.sizes) loader.sizes = candidate.sizes
      if (candidate.src) loader.src = candidate.src

      return true
    }

    const warmUrl = (url, srcset, sizes) => {
      if (!url && !srcset) return false
      const cacheKey = `${url || ''}|${srcset || ''}|${sizes || ''}`
      if (warmedKeys.has(cacheKey)) return false
      warmedKeys.add(cacheKey)

      const loader = new Image()
      loader.decoding = 'async'
      if ('fetchPriority' in loader) loader.fetchPriority = 'low'
      if (srcset) loader.srcset = srcset
      if (sizes) loader.sizes = sizes
      if (url) loader.src = url
      return true
    }

    const warmQueue = (images, options = {}) => {
      if (!shouldWarm()) return
      const list = [...images].filter(Boolean)
      if (!list.length) return

      const gap = options.gap ?? 2500
      const startDelay = options.delay ?? 2000
      const engageRoot = options.engageRoot || null
      const engageCount = Math.max(1, options.engageCount ?? 2)
      let index = 0
      let started = false

      const preloadNext = () => {
        if (index >= list.length) return
        warmImg(list[index])
        index += 1
        if (index < list.length) runWhenIdle(preloadNext, gap)
      }

      const start = () => {
        if (started) return
        started = true
        preloadNext()
      }

      const warmLikelyNext = () => {
        if (!shouldWarm()) return
        started = true
        const end = Math.min(list.length, index + engageCount)
        while (index < end) {
          warmImg(list[index])
          index += 1
        }
      }

      runAfterLoad(start, startDelay)

      if (engageRoot) {
        engageRoot.addEventListener('pointerdown', warmLikelyNext, { passive: true })
      }
    }

    const scheduleRoot = (root) => {
      if (!root || root.dataset.imageWarmInit === 'true') return
      if (!shouldWarm()) return
      if (!root.getClientRects().length) return
      root.dataset.imageWarmInit = 'true'

      const selector = root.getAttribute('data-image-warm-selector') || 'img'
      const skip = Math.max(0, Number(root.getAttribute('data-image-warm-skip') || 0))
      const limit = Math.max(0, Number(root.getAttribute('data-image-warm-limit') || 4))
      const gap = Number(root.getAttribute('data-image-warm-gap') || 2500)
      const delay = Number(root.getAttribute('data-image-warm-delay') || 2000)
      const images = [...root.querySelectorAll(selector)]
        .filter((img) => {
          const card = img.closest('.product-card')
          return !(card && card.hidden)
        })
        .slice(skip, skip + limit)

      const begin = (warmDelay) =>
        warmQueue(images, { gap, delay: warmDelay ?? delay, engageRoot: root })
      const rect = root.getBoundingClientRect()
      const nearViewport = rect.top <= window.innerHeight * 1.5 && rect.bottom >= -window.innerHeight * 0.5

      if (nearViewport || typeof IntersectionObserver === 'undefined') {
        begin()
        return
      }

      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return
          observer.disconnect()
          begin(200)
        },
        { rootMargin: '800px 0px' }
      )
      observer.observe(root)
    }

    const scan = (scope) => {
      const root = scope && scope.querySelectorAll ? scope : document
      root.querySelectorAll('[data-image-warm-root]').forEach(scheduleRoot)
    }

    window.FroartImageWarm = {
      shouldWarm,
      runWhenIdle,
      runAfterLoad,
      warmImg,
      warmUrl,
      warmQueue,
      scheduleRoot,
      scan,
    }

    const boot = () => {
      if (!shouldWarm()) return
      scan(document)
    }

    runAfterLoad(boot, 3500)
  })()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["inventory-quantity-limit"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.FroartInventory) return

    const rules = window.FroartInventoryRules
    if (!rules) return

    const labelsEl = document.getElementById('inventory-limit-labels')
    const labels = labelsEl ? JSON.parse(labelsEl.textContent) : {}
    const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'
    const cartUrl = `${shopRoot}cart`
    const cartJsUrl = `${cartUrl}.js`
    const variantLimitCache = new Map()

    const productHandleFromLine = rules.productHandleFromLine
    const shouldCapInventory = rules.shouldCapInventory
    const variantStockMax = rules.variantStockMax
    const maxFromLimit = rules.maxFromLimit

    const seedLimit = (variantId, limit, handle) => {
      const id = Number(variantId)
      if (!id || !limit) return
      variantLimitCache.set(id, { ...limit, handle: handle || null })
    }

    const loadBootstrap = () => {
      const bootstrapEl = document.getElementById('cart-inventory-bootstrap')
      if (!bootstrapEl) return
      try {
        JSON.parse(bootstrapEl.textContent || '[]').forEach((row) => {
          seedLimit(row.variant_id, {
            managed: Boolean(row.managed),
            policy: row.policy,
            max: Number(row.max || 0)
          }, row.handle)
        })
      } catch (e) {
        console.warn('cart-inventory-bootstrap parse failed', e)
      }
    }

    const clampQtyValue = (input, max) => {
      if (!input || max === null) return
      input.value = String(rules.clampedQty(input.value, max))
    }

    const whenReady = (callback) => {
      if (typeof callback !== 'function') return
      if (window.FroartInventory) {
        callback(window.FroartInventory)
        return
      }
      document.addEventListener('froart:inventory:ready', function handler() {
        document.removeEventListener('froart:inventory:ready', handler)
        callback(window.FroartInventory)
      })
    }

    const inventoryMaxForVariantId = (variantId) => {
      loadBootstrap()
      return maxFromLimit(variantLimitCache.get(Number(variantId)))
    }

    const limitMessage = (max) => rules.limitMessage(labels.limit, max)

    const limitInCartMessage = () => labels.limitInCart || ''

    const showQtyLimitHint = (hintEl, max) => {
      if (!hintEl || max === null || max < 1) return
      hintEl.hidden = false
      hintEl.textContent = limitMessage(max)
    }

    const hideQtyLimitHint = (hintEl) => {
      if (!hintEl) return
      hintEl.hidden = true
      hintEl.textContent = ''
    }

    const indicateQtyOverLimit = ({ hintEl, qtyInput, max }) => {
      if (!hintEl || !qtyInput || max === null || max < 1) return false
      const val = parseInt(qtyInput.value, 10) || 1
      if (val > max) {
        showQtyLimitHint(hintEl, max)
        qtyInput.setAttribute('aria-describedby', 'quantity-limit-hint')
        return true
      }
      hideQtyLimitHint(hintEl)
      qtyInput.removeAttribute('aria-describedby')
      return false
    }

    const fetchCart = async () => {
      const res = await fetch(cartJsUrl, { headers: { Accept: 'application/json' } })
      if (!res.ok) return null
      return res.json()
    }

    const qtyInCart = async (variantId, cart) => {
      const payload = cart || await fetchCart()
      return rules.qtyInCart(variantId, payload)
    }

    const fetchVariantLimit = async (variantId, productHandle) => {
      loadBootstrap()
      const id = Number(variantId)
      if (!id) return null

      const cached = variantLimitCache.get(id)
      if (cached) return cached

      const handle = productHandle || cached?.handle
      if (!handle) return null

      const res = await fetch(`${shopRoot}products/${encodeURIComponent(handle)}.js`, {
        headers: { Accept: 'application/json' }
      })
      if (!res.ok) return null

      const product = await res.json()
      const variant = (product.variants || []).find((entry) => Number(entry.id) === id)
      if (!variant) return null

      const limit = {
        managed: Boolean(variant.inventory_management),
        policy: variant.inventory_policy,
        max: Number(variant.inventory_quantity || 0),
        handle
      }
      variantLimitCache.set(id, limit)
      return limit
    }

    const remainingForVariant = async (variant) => {
      const stock = variantStockMax(variant)
      if (stock === null) return null
      const inCart = await qtyInCart(variant && variant.id)
      return rules.remaining(stock, inCart)
    }

    const remainingForVariantId = async (variantId, productHandle, cart) => {
      const limit = await fetchVariantLimit(variantId, productHandle)
      const stock = maxFromLimit(limit)
      if (stock === null) return null
      const inCart = await qtyInCart(variantId, cart)
      return rules.remaining(stock, inCart)
    }

    const setControlDisabled = (el, disabled) => {
      if (!el) return
      if (disabled) {
        el.setAttribute('disabled', '')
        el.setAttribute('aria-disabled', 'true')
      } else {
        el.removeAttribute('disabled')
        el.removeAttribute('aria-disabled')
      }
    }

    const syncQtyStepper = (qtyInput) => {
      if (!qtyInput) return
      const stepper = qtyInput.closest('[data-qty-stepper]')
      if (!stepper) return
      const min = parseInt(qtyInput.min, 10) || 1
      const maxAttr = qtyInput.getAttribute('max')
      const max = maxAttr != null && maxAttr !== '' ? parseInt(maxAttr, 10) : null
      const val = parseInt(qtyInput.value, 10) || min
      const locked = qtyInput.disabled
      const dec = stepper.querySelector('[data-qty-step="-1"]')
      const inc = stepper.querySelector('[data-qty-step="1"]')
      const singleChoice = locked || (max !== null && !Number.isNaN(max) && max <= 1)
      stepper.classList.toggle('product__qty-control--single', singleChoice)
      setControlDisabled(dec, locked || val <= min)
      setControlDisabled(inc, locked || (max !== null && !Number.isNaN(max) && val >= max))
    }

    const applyQtyInputMax = (input, maxRemaining) => {
      if (!input) return
      if (maxRemaining === null) {
        input.removeAttribute('max')
        setControlDisabled(input, false)
        syncQtyStepper(input)
        return
      }
      if (maxRemaining < 1) {
        input.removeAttribute('max')
        setControlDisabled(input, true)
        syncQtyStepper(input)
        return
      }
      setControlDisabled(input, false)
      input.setAttribute('max', String(maxRemaining))
      const current = parseInt(input.value, 10) || 1
      if (current > maxRemaining) input.value = String(maxRemaining)
      if (current < 1) input.value = '1'
      syncQtyStepper(input)
    }

    const setPurchaseControls = ({ remaining, qtyInput, hintEl, addBtn }) => {
      if (remaining === null) {
        setControlDisabled(qtyInput, false)
        setControlDisabled(addBtn, false)
        if (qtyInput) qtyInput.removeAttribute('max')
        if (hintEl) {
          hintEl.hidden = true
          hintEl.textContent = ''
        }
        if (qtyInput) qtyInput.removeAttribute('aria-describedby')
        syncQtyStepper(qtyInput)
        return
      }

      if (remaining < 1) {
        applyQtyInputMax(qtyInput, 0)
        setControlDisabled(addBtn, true)
        if (hintEl) {
          hintEl.hidden = false
          hintEl.textContent = limitInCartMessage()
        }
        if (qtyInput) qtyInput.setAttribute('aria-describedby', 'quantity-limit-hint')
        return
      }

      setControlDisabled(addBtn, false)
      applyQtyInputMax(qtyInput, remaining)
      hideQtyLimitHint(hintEl)
      if (qtyInput) qtyInput.removeAttribute('aria-describedby')
    }

    const invalidateVariant = (variantId) => {
      variantLimitCache.delete(Number(variantId))
    }

    const invalidateVariants = (variantIds) => {
      if (!variantIds) return
      variantIds.forEach((id) => invalidateVariant(id))
    }

    const clearCache = () => variantLimitCache.clear()

    const notifyCartUpdated = (cart) => {
      document.dispatchEvent(new CustomEvent('froart:cart:updated', { detail: { cart } }))
    }

    window.FroartInventory = {
      labels,
      cartJsUrl,
      shopRoot,
      shouldCapInventory,
      variantStockMax,
      clampQtyValue,
      whenReady,
      maxFromLimit,
      inventoryMaxForVariantId,
      fetchVariantLimit,
      qtyInCart,
      remainingForVariant,
      remainingForVariantId,
      applyQtyInputMax,
      syncQtyStepper,
      setPurchaseControls,
      limitMessage,
      limitInCartMessage,
      showQtyLimitHint,
      hideQtyLimitHint,
      indicateQtyOverLimit,
      clearCache,
      invalidateVariant,
      invalidateVariants,
      loadBootstrap,
      notifyCartUpdated,
      productHandleFromLine,
      seedLimit
    }

    document.dispatchEvent(new CustomEvent('froart:inventory:ready'))
  })()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["language-switcher"] && !Shopify.designMode) return;
  try {
    (() => {
    const switchers = document.querySelectorAll('.lang-sw')
    if (!switchers.length) return

    const firstSwitcher = switchers[0]
    const stripPrefixes = (firstSwitcher.dataset.localeStripPrefixes || '')
      .split(',')
      .map((prefix) => prefix.trim())
      .filter(Boolean)
      .sort((a, b) => b.length - a.length)

    const stripLocalePrefix = (pathname) => {
      let innerPath = pathname || '/'

      stripPrefixes.forEach((prefix) => {
        if (innerPath === prefix) {
          innerPath = '/'
        } else if (innerPath.startsWith(`${prefix}/`)) {
          innerPath = innerPath.slice(prefix.length)
        }
      })

      if (!innerPath.startsWith('/')) innerPath = `/${innerPath}`
      return innerPath
    }

    const enPrefix = firstSwitcher.dataset.enPrefix || ''
    const plPrefix = firstSwitcher.dataset.plPrefix || ''
    const currentBase = firstSwitcher.dataset.currentBase || 'pl'
    const ctParam = 'filter.p.m.custom.collection_type'
    const maps = {}
    const mapLoads = {}
    const collectionTypeAliases = {
      pierscienie: 'Rings',
      piercienie: 'Rings',
      pierscionki: 'Rings',
      piercionki: 'Rings',
      pierscionek: 'Rings',
      piercionek: 'Rings',
      kolczyki: 'Earrings',
      bransoletki: 'Bracelets',
      bransoletka: 'Bracelets',
      wisiorki: 'Pendants',
      wisiorek: 'Pendants',
      zawieszki: 'Pendants',
      zawieszka: 'Pendants',
      lancuszki: 'Chains',
      lancuszek: 'Chains',
      naszyjniki: 'Necklaces',
      broszki: 'Brooches',
      broszka: 'Brooches',
      zareczynowe: 'Engagement',
      kolekcje: 'Collections',
      komplety: 'Sets',
      'bizuteria-meska': 'Man Jewelry',
      'bizuteria-dla-mezczyzn': 'Man Jewelry'
    }

    try {
      maps[currentBase] = JSON.parse(firstSwitcher.dataset.collectionTypeMap || '{}')
    } catch (err) {
      maps[currentBase] = {}
    }

    try {
      const stored = JSON.parse(sessionStorage.getItem('froart_ct_maps') || '{}')
      Object.keys(stored).forEach((base) => {
        if (
          base !== currentBase
          && stored[base]
          && typeof stored[base] === 'object'
          && Object.keys(stored[base]).length
        ) {
          maps[base] = stored[base]
        }
      })
      sessionStorage.setItem('froart_ct_maps', JSON.stringify(maps))
    } catch (err) {}

    const handleize = (value) => value
      .replace(/ł/gi, 'l')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')

    const canonicalCollectionType = (value) => {
      if (!value) return ''
      const known = Object.values(maps)
      for (let i = 0; i < known.length; i += 1) {
        if (known[i] && Object.prototype.hasOwnProperty.call(known[i], value)) return value
      }
      for (let i = 0; i < known.length; i += 1) {
        const map = known[i]
        if (!map) continue
        const keys = Object.keys(map)
        for (let k = 0; k < keys.length; k += 1) {
          if (map[keys[k]] === value) return keys[k]
        }
      }
      return collectionTypeAliases[handleize(value)] || ''
    }

    const localizedCollectionType = (value, targetBase) => {
      const canonical = canonicalCollectionType(value)
      const map = maps[targetBase]
      if (canonical && map && map[canonical]) return map[canonical]
      if (canonical) return canonical
      return value
    }

    const persistMaps = () => {
      try {
        sessionStorage.setItem('froart_ct_maps', JSON.stringify(maps))
      } catch (err) {}
    }

    const mapReady = (base) => !!(maps[base] && Object.keys(maps[base]).length)

    const loadCollectionTypeMap = (base) => {
      if (mapReady(base)) return Promise.resolve(maps[base])
      if (mapLoads[base]) return mapLoads[base]
      const prefix = base === 'pl' ? plPrefix : enPrefix
      const url = `${prefix}/collections/all?view=collection-type-map`
      mapLoads[base] = fetch(url, { credentials: 'same-origin' })
        .then((res) => {
          if (!res.ok) throw new Error('map')
          return res.text()
        })
        .then((text) => {
          const match = text.match(/<!--froart-ct-map-->([\s\S]*?)<!--\/froart-ct-map-->/)
          if (!match) throw new Error('map')
          const map = JSON.parse(match[1].trim())
          if (!map || !Object.keys(map).length) throw new Error('map')
          maps[base] = map
          persistMaps()
          return map
        })
        .catch(() => null)
      return mapLoads[base]
    }

    const localizeSwitchSearch = (search, targetBase) => {
      if (!search) return ''
      const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)
      const dropKeys = []
      params.forEach((_, key) => {
        if ((key.startsWith('filter.') && key !== ctParam) || key === 'page') dropKeys.push(key)
      })
      dropKeys.forEach((key) => params.delete(key))
      if (params.has(ctParam)) {
        params.set(ctParam, localizedCollectionType(params.get(ctParam), targetBase))
      }
      const next = params.toString()
      return next ? `?${next}` : ''
    }

    const legalPageHandle = (pathname, search) => {
      const match = (pathname || '').match(/\/(?:pages|policies)\/([^/?#]+)\/?$/)
      let handle = match ? match[1] : ''
      const polishLegalHandles = {
        'polityka-prywatnosci': 'privacy-policy',
        'warunki-swiadczenia-uslug': 'terms-of-service',
        'dostawa-zwroty': 'delivery-returns',
        'polityka-cookies': 'cookie-policy',
        'wymagania-gpsr': 'gpsr-compliance',
      }
      if (polishLegalHandles[handle]) handle = polishLegalHandles[handle]
      if (handle === 'refund-policy' || handle === 'shipping-policy') handle = 'delivery-returns'
      if (
        handle === 'privacy-policy' ||
        handle === 'terms-of-service' ||
        handle === 'delivery-returns' ||
        handle === 'cookie-policy' ||
        handle === 'gpsr-compliance'
      ) return handle

      const params = new URLSearchParams(search && search.startsWith('?') ? search.slice(1) : search || '')
      const slug = params.get('legal') || ''
      if (slug === 'privacy') return 'privacy-policy'
      if (slug === 'terms') return 'terms-of-service'
      if (slug === 'delivery-returns' || slug === 'refund' || slug === 'shipping') return 'delivery-returns'
      if (slug === 'cookies') return 'cookie-policy'
      if (slug === 'gpsr') return 'gpsr-compliance'
      return ''
    }

    const buildLocaleUrl = (targetPrefix, targetBase, pathname, search, hash) => {
      const legalHandle = legalPageHandle(pathname, search)
      if (legalHandle) {
        const root = targetPrefix || ''
        return new URL(`${root}/pages/${legalHandle}${hash || ''}`, window.location.origin).href
      }

      const innerPath = stripLocalePrefix(pathname)
      const targetPath = `${targetPrefix || ''}${innerPath}`
      const nextSearch = localizeSwitchSearch(search, targetBase)
      return new URL(`${targetPath}${nextSearch || ''}${hash || ''}`, window.location.origin).href
    }

    const localeHref = (link) => {
      const hrefLang = (link.getAttribute('hreflang') || '').toLowerCase()
      const targetBase = hrefLang === 'pl' ? 'pl' : 'en'
      const targetPrefix = hrefLang === 'pl' ? plPrefix : enPrefix
      return buildLocaleUrl(
        targetPrefix,
        targetBase,
        window.location.pathname,
        window.location.search,
        window.location.hash
      )
    }

    const refreshLocaleLinks = () => {
      switchers.forEach((switcher) => {
        switcher.querySelectorAll('.lang-sw__code[href]').forEach((link) => {
          link.href = localeHref(link)
        })
      })
    }

    const desktopDetailsList = []

    switchers.forEach((switcher) => {
      switcher.querySelectorAll('.lang-sw__code[href]').forEach((link) => {
        link.addEventListener('click', (event) => {
          const hrefLang = (link.getAttribute('hreflang') || '').toLowerCase()
          const targetBase = hrefLang === 'pl' ? 'pl' : 'en'
          try {
            localStorage.setItem('froart_lang_choice', targetBase)
          } catch (err) {}
          if (mapReady(targetBase)) {
            link.href = localeHref(link)
            return
          }
          event.preventDefault()
          loadCollectionTypeMap(targetBase).finally(() => {
            window.location.href = localeHref(link)
          })
        })
      })

      const desktopDetails = switcher.querySelector('.lang-sw__desktop')
      if (desktopDetails) desktopDetailsList.push(desktopDetails)
    })

    if (desktopDetailsList.length) {
      document.addEventListener('click', (e) => {
        desktopDetailsList.forEach((details) => {
          if (!details.contains(e.target)) details.removeAttribute('open')
        })
      })
    }

    refreshLocaleLinks()
    const otherBase = currentBase === 'pl' ? 'en' : 'pl'
    loadCollectionTypeMap(otherBase).then((map) => {
      if (map) refreshLocaleLinks()
    })
  })()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const popup = document.querySelector('[data-newsletter-popup]')
    if (!popup) return
    if (popup.dataset.popupInit == 'true') return
    popup.dataset.popupInit = 'true'

    const close = popup.querySelector('[data-newsletter-popup-close]')
    const dismissKey = 'theme-newsletter-popup-dismissed'
    const mobileSeenKey = 'theme-newsletter-popup-mobile-seen'
    const consentKey = 'theme-cookie-consent'
    const isDesktop = window.matchMedia('(min-width: 768px)').matches

    try {
      if (localStorage.getItem(dismissKey) == '1') return
    } catch (e) {}

    const reveal = () => {
      popup.hidden = false
      document.body.classList.add('newsletter-popup-open')
      requestAnimationFrame(() => popup.classList.add('is-visible'))
    }

    const dismiss = () => {
      popup.classList.remove('is-visible')
      document.body.classList.remove('newsletter-popup-open')
      setTimeout(() => {
        popup.hidden = true
      }, 300)
      try {
        localStorage.setItem(dismissKey, '1')
      } catch (e) {}
    }

    close?.addEventListener('click', dismiss)

    const consentDone = () => {
      try { return !!localStorage.getItem(consentKey) } catch (e) { return true }
    }

    const cookieBanner = document.querySelector('[data-cookie-banner]')
    const needsWait = cookieBanner && !consentDone()

    const startDesktop = () => setTimeout(reveal, 3000)

    const startMobile = () => {
      try { if (sessionStorage.getItem(mobileSeenKey) == '1') return } catch (e) {}
      const onScroll = () => {
        if (window.scrollY < 120) return
        try { sessionStorage.setItem(mobileSeenKey, '1') } catch (e) {}
        reveal()
        window.removeEventListener('scroll', onScroll)
      }
      window.addEventListener('scroll', onScroll, { passive: true })
    }

    if (isDesktop) {
      if (needsWait) {
        document.addEventListener('theme:cookie-resolved', startDesktop, { once: true })
      } else {
        startDesktop()
      }
      return
    }

    if (needsWait) {
      document.addEventListener('theme:cookie-resolved', startMobile, { once: true })
    } else {
      startMobile()
    }
  })()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-wishlist"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__froartWishlistReady) return
    window.__froartWishlistReady = true

    var STORAGE_KEY_GUEST = 'theme-wishlist-product-ids::guest'
    var HANDLES_KEY_GUEST = 'theme-wishlist-handles::guest'

    function getStorageKey(btn) {
      var isAuthenticated = btn.getAttribute('data-customer-authenticated') === 'true'
      if (!isAuthenticated) return STORAGE_KEY_GUEST
      var customerId = String(btn.getAttribute('data-customer-id') || '')
      if (!customerId) return STORAGE_KEY_GUEST
      return 'theme-wishlist-product-ids::customer-' + customerId
    }

    function getHandlesKey(btn) {
      var isAuthenticated = btn.getAttribute('data-customer-authenticated') === 'true'
      if (!isAuthenticated) return HANDLES_KEY_GUEST
      var customerId = String(btn.getAttribute('data-customer-id') || '')
      if (!customerId) return HANDLES_KEY_GUEST
      return 'theme-wishlist-handles::customer-' + customerId
    }

    function readIds(storageKey) {
      try {
        var raw = localStorage.getItem(storageKey)
        if (!raw) return []
        var parsed = JSON.parse(raw)
        return Array.isArray(parsed) ? parsed : []
      } catch (e) {
        return []
      }
    }

    function writeIds(storageKey, ids) {
      try {
        localStorage.setItem(storageKey, JSON.stringify(ids))
      } catch (e) {}
    }

    function readHandles(key) {
      try {
        var raw = localStorage.getItem(key)
        if (!raw) return {}
        var parsed = JSON.parse(raw)
        return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {}
      } catch (e) {
        return {}
      }
    }

    function writeHandles(key, map) {
      try {
        localStorage.setItem(key, JSON.stringify(map))
      } catch (e) {}
    }

    function syncButton(btn, ids) {
      var id = String(btn.getAttribute('data-product-id') || '')
      var on = ids.indexOf(id) !== -1
      btn.setAttribute('aria-pressed', on ? 'true' : 'false')
      var add = btn.getAttribute('data-label-add')
      var rem = btn.getAttribute('data-label-remove')
      if (add && rem) {
        btn.setAttribute('aria-label', on ? rem : add)
      }
    }

    function syncAll() {
      document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
        syncButton(btn, readIds(getStorageKey(btn)))
      })
    }

    function eventElement(event) {
      var node = event && event.target
      while (node && node.nodeType !== 1) node = node.parentElement
      return node || null
    }

    document.addEventListener('click', function (e) {
      var target = eventElement(e)
      if (!target) return
      var btn = target.closest('[data-wishlist-toggle]')
      if (!btn) return

      e.preventDefault()
      e.stopPropagation()

      var id = String(btn.getAttribute('data-product-id') || '')
      if (!id) return

      var isAuthenticated = btn.getAttribute('data-customer-authenticated') === 'true'
      if (!isAuthenticated) {
        var registerMessage = btn.getAttribute('data-register-confirm-message')
        var registerUrl = btn.getAttribute('data-register-url')
        if (registerMessage && registerUrl && window.confirm(registerMessage)) {
          window.location.href = registerUrl
        }
        return
      }

      var sk = getStorageKey(btn)
      var hk = getHandlesKey(btn)
      var next = readIds(sk)
      var handles = readHandles(hk)
      var handle = String(btn.getAttribute('data-product-handle') || '')
      var i = next.indexOf(id)
      if (i === -1) {
        next.push(id)
        if (handle) handles[id] = handle
      } else {
        next.splice(i, 1)
        delete handles[id]
      }
      writeIds(sk, next)
      writeHandles(hk, handles)
      syncButton(btn, next)
    })

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncAll, { once: true })
    } else {
      syncAll()
    }
  })()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (!window.matchMedia('(hover: hover)').matches) return;

    const loaded = new WeakSet();
    const prefetchedPdps = new Set();

    function markAltReady(container) {
      if (container) container.classList.add('is-alt-ready');
    }

    function bindAltImageReady(container, img) {
      if (!container || !img) return;
      if (img.complete) {
        markAltReady(container);
        return;
      }
      img.addEventListener(
        'load',
        function () {
          markAltReady(container);
        },
        { once: true }
      );
      img.addEventListener(
        'error',
        function () {
          markAltReady(container);
        },
        { once: true }
      );
    }

    function initInlineAltImages(root) {
      (root || document).querySelectorAll('.product-card__image--alt img').forEach(function (img) {
        bindAltImageReady(img.closest('.product-card__image--alt'), img);
      });
    }

    function prefetchPdpLink(link) {
      if (!link || !window.matchMedia('(hover: hover)').matches) return;
      if (navigator.connection?.saveData) return;
      const href = link.getAttribute('href');
      if (!href || prefetchedPdps.has(href)) return;
      prefetchedPdps.add(href);
      const prefetch = document.createElement('link');
      prefetch.rel = 'prefetch';
      prefetch.href = href;
      document.head.appendChild(prefetch);
    }

    function loadAltImage(container) {
      if (!container || loaded.has(container) || container.querySelector('img')) return;
      loaded.add(container);

      const img = document.createElement('img');
      img.src = container.dataset.altSrc;
      if (container.dataset.altSrcset) {
        img.srcset = container.dataset.altSrcset;
        img.sizes = container.dataset.altSizes || '';
      }
      img.loading = 'eager';
      img.decoding = 'async';
      img.alt = '';
      bindAltImageReady(container, img);
      container.appendChild(img);
    }

    function maybeLoadCardAlt(card) {
      if (!card) return;
      loadAltImage(card.querySelector('[data-product-card-alt]'));
    }

    function preloadDeferredAlts(root) {
      (root || document).querySelectorAll('[data-product-card-alt]').forEach(function (container) {
        const card = container.closest('.product-card');
        if (card && card.hidden) return;
        loadAltImage(container);
      });
    }

    function schedulePostLoadPreload(root) {
      const scope = root || document;
      const grids = scope.querySelectorAll('[data-preload-product-card-alts]');
      if (!grids.length) return;

      const schedule =
        window.requestIdleCallback ||
        function (callback) {
          window.setTimeout(callback, 1500);
        };

      schedule(function () {
        grids.forEach(preloadDeferredAlts);
      });
    }

    window.FroartProductCard = {
      preloadAlts: preloadDeferredAlts,
      schedulePreload: schedulePostLoadPreload,
      initInlineAltImages: initInlineAltImages,
    };

    function eventElement(event) {
      let node = event && event.target;
      while (node && node.nodeType !== 1) node = node.parentElement;
      return node || null;
    }

    document.addEventListener(
      'pointerenter',
      function (event) {
        const target = eventElement(event);
        if (!target) return;
        const card = target.closest('.product-card');
        maybeLoadCardAlt(card);
        prefetchPdpLink(target.closest('.product-card__media-link'));
      },
      true
    );

    document.addEventListener('focusin', function (event) {
      const target = eventElement(event);
      if (!target) return;
      maybeLoadCardAlt(target.closest('.product-card'));
    });

    initInlineAltImages(document);

    if ('MutationObserver' in window) {
      const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (!node.matches?.('.product-card') && !node.querySelector?.('.product-card, [data-product-card-alt]')) {
              return;
            }
            initInlineAltImages(node);
            schedulePostLoadPreload(node);
          });
        });
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }

    if (document.readyState === 'complete') {
      schedulePostLoadPreload();
    } else {
      window.addEventListener('load', function () {
        schedulePostLoadPreload();
      }, { once: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-reveal"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.FroartScrollReveal) return

    const SELECTOR = '[data-reveal]'
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)')

    const revealAll = () => {
      document.querySelectorAll(SELECTOR).forEach((el) => {
        el.classList.add('is-revealed')
      })
    }

    const observe = () => {
      if (reduceMotion.matches || typeof IntersectionObserver === 'undefined') {
        revealAll()
        return
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return
            entry.target.classList.add('is-revealed')
            observer.unobserve(entry.target)
          })
        },
        {
          root: null,
          rootMargin: '0px 0px -8% 0px',
          threshold: 0.12,
        }
      )

      document.querySelectorAll(`${SELECTOR}:not(.is-revealed)`).forEach((el) => {
        observer.observe(el)
      })

      window.FroartScrollReveal.observer = observer
    }

    const scan = () => {
      if (reduceMotion.matches) {
        revealAll()
        return
      }
      const observer = window.FroartScrollReveal.observer
      if (!observer) {
        observe()
        return
      }
      document.querySelectorAll(`${SELECTOR}:not(.is-revealed)`).forEach((el) => {
        observer.observe(el)
      })
    }

    window.FroartScrollReveal = { scan, observe }

    const start = () => observe()
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true })
    } else {
      start()
    }

    reduceMotion.addEventListener('change', () => {
      if (reduceMotion.matches) revealAll()
    })
  })()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shopify-captcha-guard"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.FroartFormSpamGuard) return

    const honeypotFilled = (form) => {
      const honeypot = form.querySelector('[data-spam-guard-honeypot]')
      return Boolean(honeypot && honeypot.value.trim() !== '')
    }

    const submitWithCaptcha = (form) => {
      if (honeypotFilled(form)) return
      const doSubmit = () => form.submit()
      if (window.Shopify?.captcha?.protect) {
        window.Shopify.captcha.protect(form, doSubmit)
      } else {
        doSubmit()
      }
    }

    document.addEventListener(
      'submit',
      (event) => {
        const form = event.target
        if (!(form instanceof HTMLFormElement)) return
        if (!honeypotFilled(form)) return
        event.preventDefault()
        event.stopImmediatePropagation()
      },
      true
    )

    window.FroartFormSpamGuard = { submitWithCaptcha }
  })()
  } catch(e) { console.error(e); }
})();

})();
